import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { gsap } from 'gsap';
import { emitEvent } from 'ovee.js';
export default {
  name: 'modal',
  from: {
    namespace: ['page-enquire', 'page-newsletter', 'single-enquire']
  },
  before: function before(_ref) {
    var current = _ref.current;
    this.html = document.documentElement; // this.html.classList.add('is-transitioning');

    current.container.classList.add('is-loading');
    this.header = this.html.querySelector('header');
    this.header.classList.remove('is-over-media', 'is-over-color');
    setTimeout(function () {
      var videos = current.container.querySelectorAll('video');

      if (videos) {
        videos.forEach(function (obj) {
          obj.pause();
        });
      }
    });
  },
  beforeLeave: function beforeLeave() {
    this.html = document.documentElement;
    this.html.classList.add('is-page-loading');
  },
  leave: function leave(_ref2) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var current, isDelayed;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              current = _ref2.current;
              _this.html = document.documentElement;
              isDelayed = false;

              if (_this.html.classList.contains('menu-visible')) {
                isDelayed = true;
              }

              return _context.abrupt("return", new Promise(function (resolve) {
                var tl = gsap.timeline({
                  onComplete: function onComplete() {
                    emitEvent(window, 'pageOut');
                    setTimeout(function () {
                      current.container.remove();
                      resolve();
                    }, isDelayed ? 200 : 0);
                  }
                });
                tl.to(_this.html, {
                  autoAlpha: 0,
                  duration: 0.4,
                  ease: 'power1.inOut'
                });
              }));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  beforeEnter: function beforeEnter(_ref3) {
    var next = _ref3.next;
    emitEvent(window, 'afterModalLeave');
    this.html = document.documentElement;
    this.html.classList.remove('menu-visible', 'header-opaque', 'header-collapsed', 'submenu-sticky', 'is-hero-media');
    this.html.classList.add('modal-exiting');
    var parser = new DOMParser();
    var dom = parser.parseFromString(next.html, 'text/html');
    var newHeader = dom.querySelector('header');
    this.html.querySelector('header').className = newHeader.className; // gsap.set(next.container, {
    // 	autoAlpha: 0
    // });
  },
  enter: function enter(_ref4) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var next;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              next = _ref4.next;
              _this2.html = document.documentElement;
              return _context2.abrupt("return", new Promise(function (resolve) {
                next.container.classList.add('is-non-interactive');
                var tl = gsap.timeline({
                  onComplete: function onComplete() {
                    resolve();
                  }
                });
                tl.to(_this2.html, {
                  duration: 0.4,
                  autoAlpha: 1,
                  clearProps: 'all',
                  ease: 'power1.inOut'
                });
              }));

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  afterEnter: function afterEnter(_ref5) {
    var next = _ref5.next;
    next.container.classList.remove('is-non-interactive');
    next.container.style = '';
    this.html = document.documentElement; // this.html.classList.remove('is-transitioning');

    this.html.classList.remove('modal-exiting');
    this.html.classList.remove('is-page-loading');
  }
};